export default __webpack_public_path__ + "static/media/rishabh.686c2505.png";